import { render } from "./edi-settings.vue?vue&type=template&id=62d1f1e9&scoped=true"
import script from "./edi-settings.vue?vue&type=script&lang=js"
export * from "./edi-settings.vue?vue&type=script&lang=js"

import "./edi-settings.vue?vue&type=style&index=0&id=62d1f1e9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62d1f1e9"]])

export default __exports__